import mediator from "@tvg/mediator";

export const poolsNInfoModalOpenEvent = () => {
  mediator.base.dispatch({
    type: "POOLS_AND_INFO_MODAL_OPENED"
  });
};

export const poolsNInfoTabOpenEvent = ({
  label,
  trackName,
  raceNumber
}: {
  label: string;
  trackName?: string;
  raceNumber?: string;
}) => {
  mediator.base.dispatch({
    type: "POOLS_AND_INFO_TAB_OPENED",
    payload: {
      label,
      trackName,
      raceNumber
    }
  });
};
